import type {
  Thesaurus,
  ThesaurusNode,
  ThesaurusValue,
} from 'services/thesaurus/types';
import {clone} from 'schemaDefinition/functions/clone';
import {findAllNodeIds} from '../functions/findAllNodeIds';
import {getNodesAndAncestors} from '../functions/getNodesAndAncestors';

export const getTrimmedThesaurus = (
  fullThesaurus: Thesaurus,
  value: ThesaurusValue = [],
) => {
  const nodeIds = findAllNodeIds(value, fullThesaurus);
  const nodesWithAncestors = getNodesAndAncestors(nodeIds, fullThesaurus);
  const allNodeIds = nodesWithAncestors
    .map(node => [node.node.id, ...node.ancestors.map(ancestor => ancestor.id)])
    .flat();
  const trimmedThesaurus = clone(fullThesaurus);

  const trimChildren = <TNode extends ThesaurusNode>(node: TNode): TNode => {
    if (node.children) {
      node.children = node.children.filter(
        child => !child.deactivated || allNodeIds.includes(child.id),
      );
      node.children.forEach(trimChildren);
    }
    return node;
  };

  return trimChildren(trimmedThesaurus);
};
